import config from 'config';
import errorHandler from 'utils/errorHandler';

export const NOTIFY_ABOUT_ERROR = 'NOTIFY_ABOUT_ERROR';

const notifyAboutError = (field, error) => ({
  type: NOTIFY_ABOUT_ERROR,
  field,
  error,
});

const undefinedFunctionError = (field, error) => notifyAboutError(field, `${error}`);

export const fetchInvalidData = (field = 'serverRejection') => (dispatch, getState, { network }) => (
  network.get(`${config.apiHost}/broken-json`).then(
    () => {},
    error => dispatch(notifyAboutError(field, error)),
  )
).catch(error => {
  dispatch(notifyAboutError(field, error));
  errorHandler(error);
});

export const fetchWrongUrl = (field = 'serverFetch') => (dispatch, getState, { network }) => (
  network.get(`${config.apiHost}/not-exist`).then(
    () => {},
    error => dispatch(notifyAboutError(field, error)),
  ).catch(error => {
    dispatch(notifyAboutError(field, error));
    errorHandler(error);
  })
);

export const invalidFunctionReference = (field = 'serverReferenceError') => (dispatch) => {
  try {
    callUndefined(); // eslint-disable-line no-undef
  } catch (error) {
    dispatch(undefinedFunctionError(field, error));
  }
};
